// Winners (Prizes v2) summary hook — react-query, ~5min stale time + refetch
// on focus per Phase P3. Shared by the Winners section (currently its only
// consumer); react-query dedupes the underlying request across future
// consumers the same way useEngagementData does for the engagement summary.
//
// A failed fetch resolves to DISABLED_ENGAGEMENT_WINNERS (periods: []) rather
// than throwing, so the Winners section can render its own empty state
// unconditionally without extra error-branching.
//
// `enabled` (default true) threads through to react-query's own `enabled`
// option — WinnersSection passes engagement_summary's `winnersAvailable`
// (Prizes v2 gating) so the winners endpoint is never even called until some
// prize has actually been awarded.

import {useQuery} from '@tanstack/react-query';
import {fetchEngagementWinners} from './leaderboardService';
import {DISABLED_ENGAGEMENT_WINNERS, EngagementWinners} from './types';

const STALE_MS = 5 * 60 * 1000;

export function useWinnersData(options: {enabled?: boolean} = {}) {
  const enabled = options.enabled ?? true;
  const query = useQuery<EngagementWinners, Error>(
    ['engagementWinners'],
    () => fetchEngagementWinners(),
    {
      enabled,
      staleTime: STALE_MS,
      refetchOnWindowFocus: true,
      retry: 1,
    },
  );

  return {
    winners: query.data ?? DISABLED_ENGAGEMENT_WINNERS,
    isLoading: query.isLoading,
    isError: query.isError,
  };
}
